import {IPlayer, LocalStorage} from "../types";

export const addUpdatePlayerToStorage = (player:IPlayer) => {
    const otherPlayers = JSON.parse(localStorage.getItem(LocalStorage.PLAYERS_STORAGE) || "[]").filter((p:any) => p.id !== player.id);
    localStorage.setItem(LocalStorage.PLAYERS_STORAGE, JSON.stringify([...otherPlayers, player]))
};

export const deletePlayerFromStorage = (playerId:string) => {
    const otherPlayers = JSON.parse(localStorage.getItem(LocalStorage.PLAYERS_STORAGE) || "[]").filter((p:any) => p.id !== playerId);
    localStorage.setItem(LocalStorage.PLAYERS_STORAGE, JSON.stringify(otherPlayers));
};

export const getPlayersFromStorage = ():IPlayer[] => {
    return JSON.parse(localStorage.getItem(LocalStorage.PLAYERS_STORAGE) || "[]");
};
